import {
    FETCH_BRANCHES,
    SET_BRANCH,
    RESET_BRANCH
} from './types';

export const fetchBranches = payload => {
    return {
        type: FETCH_BRANCHES,
        payload
    };
};

export const setBranch = payload => {
    return {
        type: SET_BRANCH,
        payload
    };
};

export const resetBranch = () => {
    return {
        type: RESET_BRANCH
    };
};